module.exports = __webpack_public_path__ + "static/media/onde-comprar-shop.d6fb86d1.svg";